import {Component, OnInit,Inject} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

export interface Ques_Ans {
  Qus: string;
  Ans:  string;
}

export interface DialogData {
  animal: string;
  name: string;
}
@Component({
  selector: 'Generaldialog-modal',
  templateUrl: 'Generaldialog.component.html',
})

export class GeneralDialoag {
  index: number;
	 // MatPaginator Inputs
  length = 100;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  checked = false;

    // MatPaginator Output
  pageEvent: PageEvent;
  
  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
  }
  desserts1: Ques_Ans[] = [
    {Qus: 'patient name', Ans: 'Shinah'},
    {Qus: 'patient Age', Ans: '26'},
    {Qus: 'patient name', Ans: 'Shinah'},
    {Qus: 'patient Age', Ans: '26'},
    {Qus: 'patient name', Ans: 'Shinah'},
    {Qus: 'patient Age', Ans: '26'},
    {Qus: 'patient name', Ans: 'Shinah'},
    {Qus: 'patient Age', Ans: '26'},
    {Qus: 'patient name', Ans: 'Shinah'},
    {Qus: 'patient Age', Ans: '26'},
    {Qus: 'patient name', Ans: 'Shinah'},
    {Qus: 'patient Age', Ans: '26'},
  ];
  sortedData1: Ques_Ans[];

  constructor(
    public dialogRef: MatDialogRef<GeneralDialoag>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) 
    {
      this.sortedData1 = this.desserts1.slice();
    }

  onNoClick(): void {
    this.dialogRef.close();
  }
  
  sortData(sort: Sort) {
    const data = this.desserts1.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData1 = data;
      return;
    }

    this.sortedData1 = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
         
        case 'Qus': return compare(a.Qus, b.Qus, isAsc); 
        case 'Ans': return compare(a.Ans, b.Ans, isAsc);       
        
      
        default: return 0;
      }
    });


}

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
